module.exports = __webpack_public_path__ + "static/media/LK__Error.97ef8ee2.svg";